/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import { LazyLoadImages, ResponsiveImage } from "@quintype/components";
import get from "lodash.get";
import PropTypes from "prop-types";
import React from "react";
import { shapeStory } from "../../../../utils/utils";
import { GlideCarousel } from "../../../Glide/glide";
import { FullScreenImages } from "../../../Molecules/FullScreenImages";
import { withElementWrapper } from "../withElementWrapper";
import "./image-slideshow.m.css";

const ImageSlideshowBase = props => {
  if (!props.element) return null;
  let resizeDone = false;

  const resize = () => {
    if (resizeDone === false) {
      window.dispatchEvent(new window.Event("resize"));
      resizeDone = true;
    }
  };

  const sliderSettings = {
    afterSlide: resize,
    perView: 1,
    arrow: true,
    dot: "",
    autoplay: 5000,
    ...props
  };

  const Slide = (image, index, onClickHandler) => {
    const { id, "image-s3-key": imageS3Key, metadata, title } = image;
    return (
      <div onClick={() => onClickHandler(index)} styleName="slide" key={id}>
        <figure key={id} styleName="image-container">
          <LazyLoadImages margin={"0px"}>
            <ResponsiveImage
              slug={imageS3Key}
              metadata={metadata}
              aspect-ratio={[16, 9]}
              defaultWidth={480}
              widths={[250, 480, 640]}
              imgParams={{ auto: ["format", "compress"] }}
              styleName="image"
              alt={title}
            />
          </LazyLoadImages>
        </figure>
        <p styleName="caption">{title}</p>
      </div>
    );
  };

  const ImageSlideshowTemplate = ({ onClickHandler }) => {
    const storyElements = get(props, ["element", "story-elements"], []);

    return (
      <div className="arr--image-slideshow-element" styleName="slideshow">
        <GlideCarousel {...sliderSettings}>
          {storyElements.map((image, index) => Slide(image, index, onClickHandler))}
        </GlideCarousel>
      </div>
    );
  };

  ImageSlideshowTemplate.propTypes = {
    onClickHandler: PropTypes.func
  };

  return <FullScreenImages template={ImageSlideshowTemplate} element={props.element} />;
};

ImageSlideshowBase.propTypes = {
  element: PropTypes.shape({
    "story-elements": PropTypes.array
  }),
  story: shapeStory
};

export const ImageSlideshow = withElementWrapper(ImageSlideshowBase);
